/* import __COLOCATED_TEMPLATE__ from './content-empty-state.hbs'; */
import templateOnlyComponent from '@ember/component/template-only';
export default templateOnlyComponent();